import { escapeHtml, formatDocumentType, getDocumentSideTitle } from './grcUtils';

export function printGuestDocuments(documents) {
  if (!documents) return;
  const printWindow = window.open('', '_blank');
  if (!printWindow) return;

  const documentTypeLabel = formatDocumentType(documents.document_type);
  const bookingCode = escapeHtml(documents.bookingCode || 'Booking');
  const guestName = escapeHtml(documents.guestName || '');
  const guestPhone = escapeHtml(documents.guestPhone || '');
  const frontTitle = escapeHtml(getDocumentSideTitle(documents.document_type, 'Front'));
  const backTitle = escapeHtml(getDocumentSideTitle(documents.document_type, 'Back'));

  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
      <head>
        <title>Guest Documents - ${bookingCode}</title>
        <meta charset="UTF-8">
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          @page { size: A4; margin: 15mm; }
          body {
            font-family: 'Roboto', -apple-system, BlinkMacSystemFont, 'Segoe UI', Arial, sans-serif;
            margin: 0;
            padding: 20px;
            background: white;
            color: #212121;
            line-height: 1.6;
          }
          .info-section {
            background: #fafafa;
            padding: 20px;
            border-radius: 8px;
            border: 1px solid #e0e0e0;
            margin-bottom: 30px;
          }
          .info-section h2 {
            font-size: 18px;
            font-weight: 500;
            margin-bottom: 20px;
            padding-bottom: 12px;
            border-bottom: 2px solid #4ce1b6;
          }
          .info-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
            gap: 20px;
          }
          .info-label {
            font-size: 12px;
            font-weight: 500;
            color: #757575;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            margin-bottom: 6px;
            display: block;
          }
          .info-value { font-size: 14px; color: #212121; word-break: break-word; }
          .document-section { margin-bottom: 20px; page-break-inside: avoid; }
          .document-title {
            font-size: 16px;
            font-weight: 500;
            margin-bottom: 10px;
            padding-bottom: 8px;
            border-bottom: 1px solid #e0e0e0;
          }
          .document-image {
            width: 100%;
            height: auto;
            border: 1px solid #e0e0e0;
            border-radius: 4px;
            display: block;
          }
          @media print {
            body { padding: 0; }
            .document-image { max-height: 280px; object-fit: contain; }
          }
        </style>
      </head>
      <body>
        <div class="info-section">
          <h2>Guest Information</h2>
          <div class="info-grid">
            ${documents.bookingCode ? `<div><span class="info-label">Booking ID</span><span class="info-value">${bookingCode}</span></div>` : ''}
            ${guestName ? `<div><span class="info-label">Guest Name</span><span class="info-value">${guestName}</span></div>` : ''}
            ${guestPhone ? `<div><span class="info-label">Mobile Number</span><span class="info-value">${guestPhone}</span></div>` : ''}
            ${documentTypeLabel ? `<div><span class="info-label">Document</span><span class="info-value">${escapeHtml(documentTypeLabel)}</span></div>` : ''}
          </div>
        </div>
        ${documents.id_front_url ? `
          <div class="document-section">
            <div class="document-title">${frontTitle}</div>
            <img src="${escapeHtml(documents.id_front_url)}" alt="${frontTitle}" class="document-image" />
          </div>
        ` : ''}
        ${documents.id_back_url ? `
          <div class="document-section">
            <div class="document-title">${backTitle}</div>
            <img src="${escapeHtml(documents.id_back_url)}" alt="${backTitle}" class="document-image" />
          </div>
        ` : ''}
      </body>
    </html>
  `);
  printWindow.document.close();
  const images = Array.from(printWindow.document.images || []);
  Promise.all(images.map((img) => (
    img.complete ? Promise.resolve() : new Promise((resolve) => {
      img.onload = resolve;
      img.onerror = resolve;
    })
  ))).then(() => {
    setTimeout(() => printWindow.print(), 150);
  });
}
